import { EffectiveServiceDuration, ImageModel, ServiceModel } from "../../data/entities";
import { ServiceRepo, ServiceODataRepo } from "../../data/repo";
import { ImageRequest } from "../../models";
import { BaseEntityService } from "../BaseEntityService"

export class ServiceService extends BaseEntityService<ServiceModel, ServiceRepo, ServiceODataRepo> {
  constructor(){
    super(new ServiceRepo(), new ServiceODataRepo());
  }

  async insertImage(request: ImageRequest): Promise<ImageModel> {
    return await this.repo.insertImage(request);
  }

  async deleteImage(id: number): Promise<boolean> {
    return await this.repo.deleteImage(id);
  }

  async getEffectiveServiceDurationAsync(locationId: number, providerId: number): Promise<EffectiveServiceDuration[]>{
    return await this.repo.getEffectiveServiceDurationAsync(locationId, providerId)
  }
}

export default ServiceService;
